interface GraphWithMagnificationAndGearSVGProps {
  color: string;
  style: React.CSSProperties;
}

const GraphWithMagnificationAndGearSVG = ({
  color,
  style,
}: GraphWithMagnificationAndGearSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="49"
    height="43"
    viewBox="0 0 49 43"
    fill="none"
  >
    <g clipPath="url(#clip0_1507_34128)">
      <path
        d="M34.0796 25.4931C34.6999 25.838 35.2675 26.2619 35.7681 26.7577L38.1703 26.0272C38.6158 26.59 39.011 27.2056 39.3367 27.8762C39.6625 28.5468 39.8996 29.239 40.0672 29.9359L38.0099 31.3706C38.0626 31.8376 38.0769 32.3142 38.0434 32.798C38.0075 33.2818 37.9236 33.7513 37.8039 34.2063L39.6361 35.9212C39.3703 36.587 39.0373 37.2361 38.6182 37.8564C38.1991 38.4743 37.7201 39.0252 37.2003 39.5185L34.9274 38.4527C34.1682 39.0132 33.3036 39.4371 32.3743 39.691L31.8019 42.1363C31.0929 42.2393 30.3625 42.2753 29.6176 42.2226C28.8751 42.1699 28.1566 42.031 27.4692 41.8274L27.2561 39.3245C26.3723 38.9389 25.5771 38.4001 24.9065 37.7318L22.5043 38.4623C22.0588 37.8995 21.6636 37.2864 21.3379 36.6133C21.0122 35.9427 20.775 35.2506 20.6074 34.556L22.6647 33.119C22.6121 32.6519 22.5953 32.1753 22.6312 31.6915C22.6576 31.2891 22.7246 30.8963 22.8108 30.5155"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.9229 28.2761C32.9827 28.5779 34.4916 30.4245 34.3383 32.5345C34.1778 34.7428 32.257 36.4073 30.0463 36.2469C27.8381 36.0888 26.1735 34.1656 26.334 31.9573C26.3867 31.2436 26.619 30.5874 26.9902 30.0317"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.3741 11.1922C36.6854 10.9671 37.0159 10.7635 37.368 10.5863C37.8734 10.33 38.3955 10.1408 38.9224 10.0067L40.0361 11.5515C40.7618 11.4581 41.4875 11.4964 42.1845 11.6688L43.4634 10.2605C43.9712 10.4521 44.4693 10.6964 44.9436 11.0078C45.4178 11.3167 45.8417 11.6736 46.2201 12.064L45.4417 13.8004C45.6573 14.083 45.8537 14.3848 46.0213 14.7153C46.189 15.0435 46.3159 15.3812 46.4165 15.7237L48.2775 16.1236C48.3661 16.6601 48.402 17.2134 48.3709 17.7786C48.3398 18.3438 48.2416 18.8875 48.0955 19.412L46.1986 19.606C45.9231 20.2671 45.528 20.8802 45.0202 21.4071L45.6022 23.2226C45.1831 23.5675 44.7208 23.874 44.2179 24.1303C43.7101 24.3842 43.1904 24.5734 42.6635 24.7075L41.5498 23.1651C40.8241 23.2585 40.0984 23.2178 39.399 23.0453L38.1201 24.4536C37.6123 24.262 37.1165 24.0177 36.6423 23.7064C36.3238 23.5004 36.0244 23.2705 35.7513 23.0238"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.3776 16.2626C37.6195 15.3908 38.2134 14.6172 39.0876 14.1765C40.7282 13.3478 42.7305 14.0064 43.5616 15.6471C44.3903 17.2877 43.7316 19.2923 42.091 20.121C40.4504 20.9497 38.4458 20.2911 37.6171 18.6505C37.4734 18.3654 37.3728 18.0685 37.3177 17.7667"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.02856 25.1123L2.30198 30.3551C0.668553 31.852 0.555985 34.3908 2.05529 36.0218C3.5498 37.6552 6.08856 37.7678 7.7196 36.2685L13.4462 31.0233"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1099 21.4335L7.92078 23.5148C7.51362 23.8861 7.48728 24.5184 7.85851 24.9255L13.6138 31.2078C13.9851 31.6149 14.6174 31.6413 15.0245 31.27L17.2615 29.172"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.8123 30.072C34.3481 28.1259 38.8795 20.4392 36.9334 12.9034C34.9873 5.36754 27.3007 0.836153 19.7648 2.78225C12.229 4.72835 7.69759 12.415 9.64368 19.9508C11.5898 27.4867 19.2764 32.0181 26.8123 30.072Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.8823 26.7388C29.5766 26.4105 33.9265 21.5282 33.5982 15.834C33.2699 10.1397 28.3876 5.78977 22.6933 6.11809C16.9991 6.44642 12.6492 11.3287 12.9775 17.0229C13.3058 22.7172 18.1881 27.0671 23.8823 26.7388Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4171 20.4802V16.7152H15.9107V20.4802"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.0383 20.4802V11.2545H21.5367V20.4802"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.6642 20.4803V14.6914H27.1579V20.4803"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.6642 20.4802H15.9107"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1507_34128">
        <rect width="50" height="43" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default GraphWithMagnificationAndGearSVG;
